'use client';

import { FC, ReactNode } from 'react';

interface Props {
  savedSearch: ReactNode;
}

export const StickySavedSearch: FC<Props> = ({ savedSearch }) => {
  return <div className="StickySavedSearch">{savedSearch}</div>;
};
